import { AuroraV2Abilities } from "./aurora-V2.types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAuroraV2Abilities, postSyncAuroraV2Design } from "../../lib/api/proposal-api";
import { RootState } from "../../rootReducer";
import { AxiosError } from "axios";
import { EnerfloProposalData } from "@/types";

export const fetchAuroraV2Abilities = createAsyncThunk<
  { abilities: AuroraV2Abilities; externalDesignToolLink: string },
  undefined,
  { state: RootState }
>("auroraV2/fetchAuroraV2Abilities", async (_arg, thunkAPI) => {
  const proposalId = thunkAPI.getState().proposal.reportHash;

  try {
    const response = await getAuroraV2Abilities(proposalId);
    return response.data;
  } catch (e) {
    let error = e as AxiosError<any>;
    return thunkAPI.rejectWithValue({ errors: error.response?.data ?? {} });
  }
});

export const syncAuroraV2Design = createAsyncThunk<EnerfloProposalData, undefined, { state: RootState }>(
  "data/syncAuroraV2Design",
  async (_, thunkAPI) => {
    const proposalId = thunkAPI.getState().proposal.reportHash;

    try {
      const response = await postSyncAuroraV2Design(proposalId);
      return response.data;
    } catch (e) {
      let error = e as AxiosError<any>;
      return thunkAPI.rejectWithValue({ errors: error.response?.data ?? {} });
    }
  }
);
